import {
  hostKeyframeAsset,
  resolveCanonicalHost,
  type HostVisualState,
} from "@cue-the-night/host-engine";

const AVATAR_ROOT =
  "/assets/players/avatars";

const TRANSPARENT_HOST_ASSET =
  "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";

const canonicalAvatarAssets:
  Readonly<
    Record<
      string,
      string
    >
  > = {
    "avatar-001":
      `${AVATAR_ROOT}/avatar-001-forgetful.ringless.runtime.png`,

    "avatar-003":
      `${AVATAR_ROOT}/avatar-003-party-animal.ringless.runtime.png`,

    "avatar-004":
      `${AVATAR_ROOT}/avatar-004-party-queen.ringless.runtime.png`,

    "avatar-007":
      `${AVATAR_ROOT}/avatar-007-gym-bro.ringless.runtime.png`,

    "avatar-010":
      `${AVATAR_ROOT}/avatar-010-goofball.ringless.runtime.png`,

    "avatar-014":
      `${AVATAR_ROOT}/avatar-014-party-grandma.ringless.runtime.png`,

    "avatar-female-wine-lover":
      `${AVATAR_ROOT}/avatar-female-wine-lover.ringless.runtime.png`,
  };

export const playerAvatarChoices =
  [
    {
      id:
        "avatar-001",
      label:
        "Forgetful",
    },

    {
      id:
        "avatar-003",
      label:
        "Party Animal",
    },

    {
      id:
        "avatar-004",
      label:
        "Party Queen",
    },

    {
      id:
        "avatar-007",
      label:
        "Gym Bro",
    },

    {
      id:
        "avatar-010",
      label:
        "Goofball",
    },

    {
      id:
        "avatar-014",
      label:
        "Party Grandma",
    },

    {
      id:
        "avatar-female-wine-lover",
      label:
        "Wine Lover",
    },
  ] as const;

const legacyAvatarAliases:
  Readonly<
    Record<
      string,
      string
    >
  > = {
    "avatar-1":
      "avatar-001",

    "avatar-2":
      "avatar-003",

    "avatar-3":
      "avatar-004",

    "avatar-4":
      "avatar-007",

    "avatar-5":
      "avatar-010",

    "avatar-6":
      "avatar-014",
  };

const FALLBACK_AVATAR =
  canonicalAvatarAssets[
    "avatar-001"
  ] as string;

export function playerAvatarAsset(
  avatarId:
    string,
): string {
  const canonicalId =
    legacyAvatarAliases[
      avatarId
    ] ??
    avatarId;

  return (
    canonicalAvatarAssets[
      canonicalId
    ] ??
    FALLBACK_AVATAR
  );
}

export const playerRingAsset =
  "/assets/players/ring/player-ring-master.runtime.png";

/**
 * Player presentation follows the authoritative Host identity.
 *
 * Missing/unknown Host identity may never silently fall back
 * to Rex, Milo or Knox.
 */
export function gameplayHostAsset(
  hostId:
    string,
  moment:
    HostVisualState,
): string {
  const host =
    resolveCanonicalHost(
      hostId,
    );

  if (!host) {
    return TRANSPARENT_HOST_ASSET;
  }

  return hostKeyframeAsset(
    host.id,
    moment,
  );
}

export function gameplayHostName(
  hostId:
    string,
): string {
  return (
    resolveCanonicalHost(
      hostId,
    )?.displayName ??
    hostId
  );
}